var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dynamic-page",staticStyle:{"width":"100%"}},[(_vm.content)?_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"dynamic-page__content",staticStyle:{"width":"100%"},domProps:{"innerHTML":_vm._s(_vm.content)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }